import axios from 'axios';
import { Toast } from 'vant';
/**
 * 获取localSorage对应字段
 * @param {String} properName
 */
const getValue = properName => localStorage.getItem(properName)

const service = axios.create({
    timeout: 60 * 1000,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
    },
});

service.interceptors.request.use(
    config => {
        // Toast.loading({
        //     duration: 0,
        //     message: '加载中...',
        //     forbidClick: true,
        //     loadingType: 'spinner',
        // });
    console.log(config.params)

        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

service.interceptors.response.use(
    response => {
        // Toast.clear()
        return response.data;
    },
    error => {
        // Toast.clear()
        if (!error.response) {
            return Promise.reject(error);
        }
        return Promise.reject(error);
    }
);

export default service;
